export { default } from './NearbySlots';
